module.exports = __webpack_public_path__ + "assets/img/familyCrest-fafa3aaf.png";